import React, { useEffect } from "react";
import "./styles.less";

import { DocBlock } from "../components/DocBlock";
import { DocCode } from "../components/DocCode";
import { DocImg } from "../components/DocImg";

export const B2ePlayground = () => {
  useEffect(() => {
    tocbot.init({
      // Where to render the table of contents.
      tocSelector: ".m2e-toc",
      // Where to grab the headings to build the table of contents.
      contentSelector: ".m2e-toc-content",
      // Which headings to grab inside of the contentSelector element.
      headingSelector: "h1, h2, h3",
      // For headings inside relative or absolute positioned containers within content.
      hasInnerContainers: true,
      positionFixedSelector: ".m2e-toc",
      linkClass: "toc-link",
    });
  }, []);
  return (
    <div className="m2e-plauground-warp">
      <div className="m2e-plauground-inner">
        <div className="m2e-toc-content toc-content-left">
          <DocBlock title="项目简介" keyId="m2e-1">
            <div className="descript">
              <p>引用的开源项目地址：</p>
              <p>
                Gitee：
                <a
                  href="https://gitee.com/lenve/vhr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://gitee.com/lenve/vhr
                </a>
              </p>

              <p>
                Github：
                <a
                  href=" https://github.com/lenve/vhr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://github.com/lenve/vhr
                </a>
              </p>
              <p>
                项目前后端分离，前端采用 Vue2 + Javascript，后端采用
                SpringSecurity + SpringBoot，均是具有代表性的技术栈。
              </p>
              <p>
                项目说明文档中已经详细的阐述了如何部署到本地，此处仅补充说明:
              </p>
              <p>
                项目仅作示例展示用，接下来将具体介绍如何接入 Authing
                服务，有多种方式，本文侧重点在于介绍通过不改变原本项目前端
                UI，而在后端「调用 SDK 」的方式。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="预备知识" keyId="m2e-2">
            <div className="descript">
              <p>
                如果你还没有用过
                Authing，可以点击这里查看如何创建一个自己的应用。
              </p>
              <p>
                对 Authing 的任何名词/概念有疑问：
                <a href="https://docs.authing.co/v2/concepts/">
                  https://docs.authing.co/v2/concepts/
                </a>
              </p>
              <p>
                接下来，假设你已经对 Authing 有初步了解，且在 Authing
                控制台创建了一个自己的应用。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="全局配置" keyId="m2e-3">
            <div className="descript">
              <DocCode
                title="首先要在 pom.xml 文件中引入 Authing 提供的 SDK 依赖："
                code={`<dependency>
                <groupId>cn.authing</groupId>
                <artifactId>authing-java-sdk</artifactId>
                <version>{LATEST_VERSION}</version>
            </dependency>`}
                extra="最新的版本号 LATEST_VERSION 需要你根据 groupId 和 artifactId 自行到 Maven 官网查找。"
              />
              <p>
                引入 Authing 提供的 SDK 之后，要获取Authing 服务最核心的
                <b>认证侧类 AuthenticationClient</b> 和
                <b>管理侧类 ManagementClient，</b>
                通过调用这两个类中封装好的方法，就可以使用 Authing 提供的服务。
              </p>

              <p>
                可以通过在后端项目中添加 config 配置类，将 AuthenticationClient
                和 ManagementClient 作为 Bean 注入到
                Spring之中，此后在各处仅需获取 Bean
                并使用即可(例如：@Autowired)。
              </p>
              <p>
                具体地，在项目主程序同级目录下创建 config
                文件夹，在该文件夹中新建 AuthingConfig 类。
              </p>

              <DocCode
                title="示例代码如下："
                code={`@Configuration
                public class AuthingConfig {
                    @Bean
                    @Scope("prototype")
                    public AuthenticationClient authenticationClient() throws IOException, ParseException {
                        //在构造函数中分别填入自己的 App ID、App Secret、APP Host。
                        AuthenticationClientOptions options = new AuthenticationClientOptions();
                        options.setAppId("YOUR_APP_ID");
                        options.setAppSecret("YOUR_APP_SECRET");
                        options.setAppHost("YOUR_APP_HOST");
                        AuthenticationClient client = new AuthenticationClient(options);
                        return client;
                    }
                
                    @Bean
                    @Scope("prototype")
                    public ManagementClient managementClient() {
                        //在构造函数中分别填入自己的 用户池 ID、用户池 Secret、APP Host
                        ManagementClientOptions options = new ManagementClientOptions();
                        options.setAccessKeyId("YOUR_APP_ID");
                        options.setAccessKeySecret("YOUR_APP_SECRET");
                        options.setHost("YOUR_APP_HOST");
                        ManagementClient client = new ManagementClient(options);
                        return client;
                    }
                }`}
              />

              <p>如果你不知道如何获取这些数据：</p>
              <p>
                App ID、App Secret、APP Host：
                <a href="https://docs.dev.authing-inc.co/v2/guides/faqs/get-app-id-and-secret.html">
                  https://docs.dev.authing-inc.co/v2/guides/faqs/get-app-id-and-secret.html
                </a>
              </p>
              <p>
                用户池 ID、用户池 Secret：
                <a href="https://docs.authing.co/v2/guides/faqs/get-userpool-id-and-secret.html">
                  https://docs.authing.co/v2/guides/faqs/get-userpool-id-and-secret.html
                </a>
              </p>
            </div>
          </DocBlock>
          <DocBlock title="登录/注册" keyId="m2e-4">
            <div className="second-title">
              1.登录
              <div className="second-title-description">
                刚初始化的系统建议自己在 Authing
                控制台手动创建一个「超级管理员」账号用于登录
              </div>
            </div>
            <DocImg
              title="登录界面展示："
              src="//files.authing.co/authing-website/doc-img/playground-b2e-01.png"
            />
            <p>登录后端逻辑：</p>
            <DocCode
              title="自定义密码校验方法"
              code={`public class MyAuthenticationProvider extends DaoAuthenticationProvider {
    @Autowired
    AuthenticationClient authenticationClient;
    @Autowired
    HrService hrService;
    @Value("\${authing.config.appId}")
    String namespace;
    @Autowired
    ManagementClient managementClient;

    public MyAuthenticationProvider() {
    }

    // 自定义密码校验方法
    @Override
    protected void additionalAuthenticationChecks(UserDetails userDetails, UsernamePasswordAuthenticationToken authentication) throws AuthenticationException {
        String username = (String) authentication.getPrincipal();
        String password = (String) authentication.getCredentials();
        LoginTokenRespDto respDto = authenticationClient.signInByUsernamePassword(username, password, new SignInOptionsDto());
        if(respDto.getStatusCode() != 200){
            throw new AuthingException(respDto.getMessage());
        }else{
            // 把 accessToken 存到 threadLocal 中
            CurrentUserAccessToken.setAccessToken(respDto.getData().getAccessToken());
        }
        GetUserRolesDto reqDto = new GetUserRolesDto();
        reqDto.setUserIdType("username");
        reqDto.setUserId(username);
        reqDto.setNamespace(namespace);
        RolePaginatedRespDto respDto1 = managementClient.getUserRoles(reqDto);
        List<RoleDto> roleList = respDto1.getData().getList();
        // 普通员工没有赋予角色
        if(roleList.size() == 0){
            throw new AuthingException("普通员工不可登录后台系统！");
        }
//        super.additionalAuthenticationChecks(userDetails, authentication);
    }
}`}
            />
            <p>说明一下：</p>
            <div className="descript-list">
              1. 项目本身采用了 SpringSecurity 框架，登录和鉴权的一些逻辑必须与
              SpringSecurity 框架结合实现。此处新写一个类
              MyAuthenticationProvider 继承
              DaoAuthenticationProvider，并重写其中的
              additionalAuthenticationChecks() 方法，就能重写 SpringSecurity
              密码的校验过程。此处抛出异常视为校验失败，无异常则视为成功。
            </div>
            <div className="descript-list">
              2. 在方法体中注入之前配置的 AuthenticationClient，调用其
              signInByUsernamePassword() 方法，即可完成 Authing
              的「账号密码登录」 功能。得到返回对象后，判断状态码是否为 200，200
              则代表成功，成功后把 accessToken 存储到 threadLocal
              中以便后续返回给前端；不是 200
              代表失败，失败获取错误信息放到自定义异常类中抛出。
            </div>
            <div className="descript-list">
              3.
              还要做一个额外校验，该人事管理系统只有管理员能登录，普通员工无法登录，而笔者采用的区分二者的方法为普通员工没有设置角色。换句话说，被赋予角色的用户才有登录的功能，所以此处要额外判断该用户是否有角色。
            </div>
            <div className="descript-list">4. 后续处理见下文</div>
            <DocCode
              title="上述操作完成后，需要把这个类注入到 SpringSecurity 中。在 SecurityConfig 类中加入以下代码："
              code={`    @Bean
    public MyAuthenticationProvider myAuthenticationProvider() {
        MyAuthenticationProvider myAuthenticationProvider = new MyAuthenticationProvider();
        //设置passorderEncoder
        myAuthenticationProvider.setPasswordEncoder(passwordEncoder());
        //设置UserDetailsService
        myAuthenticationProvider.setUserDetailsService(hrService);
        return myAuthenticationProvider;
    }

    @Override
    protected void configure(AuthenticationManagerBuilder auth) throws Exception {
        // 注释，加上会调用默认的 DaoAuthenticationProvider，导致 myAuthenticationProvider 抛出的异常不被捕获
        //        auth.userDetailsService(hrService);
        auth.authenticationProvider(myAuthenticationProvider());
    }
    
    @Override
    protected AuthenticationManager authenticationManager(){
        ProviderManager manager = new ProviderManager(Arrays.asList(myAuthenticationProvider()));
        return manager;
    }`}
            />
            <p>登录校验后逻辑处理</p>
            <DocCode
              title="在 SecurityConfig 类中加入以下代码："
              code={`@Bean
    LoginFilter loginFilter() throws Exception {
        LoginFilter loginFilter = new LoginFilter();
        loginFilter.setAuthenticationSuccessHandler((request, response, authentication) -> {
            response.setContentType("application/json;charset=utf-8");
            PrintWriter out = response.getWriter();
            // 获取 loadUserByUserName 中返回的 hr 对象，返回给前端
            Hr hr = (Hr) authentication.getPrincipal();
            hr.setPassword(null);
            // 获取 ThreadLocal 中的 accessToken
            hr.setAccessToken(CurrentUserAccessToken.getAccessToken());
            RespBean ok = RespBean.ok("登录成功!", hr);
            String s = new ObjectMapper().writeValueAsString(ok);
            out.write(s);
            out.flush();
            out.close();
            // 清除 ThreadLocal 中的 accessToken
            CurrentUserAccessToken.removeAccessToken();
            }
        );
        loginFilter.setAuthenticationFailureHandler((request, response, exception) -> {
                    response.setContentType("application/json;charset=utf-8");
                    PrintWriter out = response.getWriter();
                    RespBean respBean = RespBean.error(exception.getMessage());
                    out.write(new ObjectMapper().writeValueAsString(respBean));
                    out.flush();
                    out.close();
                }
        );
        // set 新的 AuthenticationManager 对象
        loginFilter.setAuthenticationManager(authenticationManagerBean());
        // 登录接口
        loginFilter.setFilterProcessesUrl("/doLogin");
        return loginFilter;
    }
    
    @Override
    protected void configure(HttpSecurity http) throws Exception {
        // 自定义 filter 替换 UsernamePasswordAuthenticationFilter
        http.addFilterAt(loginFilter(), UsernamePasswordAuthenticationFilter.class);
    }`}
            />
            <p>说明一下：</p>
            <div className="descript-list">
              为了实现前后端分离登录，需要写一个类继承
              UsernamePasswordAuthenticationFilter 类，并重写其中的
              attemptAuthentication() 方法，原项目中写的是
              LoginFilter。此段代码的含义是把 LoginFilter 注入到 SpringSecurity
              中，通过 setFilterProcessesUrl()
              方法设置了登录接口（前端登录请求只要发送到这个接口即可），更改之处在于成功和失败的处理。
            </div>
            <div className="second-title">2. 登出</div>
            <DocImg
              title="登出界面展示："
              src="//files.authing.co/authing-website/doc-img/playground-b2e-02.png"
            />
            <p>登出后端逻辑：</p>
            <DocCode
              title="仅展示 SecurityConfig 中改动部分"
              code={`@Override
protected void configure(HttpSecurity http) throws Exception {
    http
    .logout()
    .logoutUrl("/logout")
    .deleteCookies("JSESSIONID")
    .logoutSuccessHandler((req, resp, authentication) -> {
                // 添加自定义登出逻辑，撤销 authing accessToken
                if(StrUtil.isNotBlank(req.getParameter("accessToken"))) {
                    authenticationClient.revokeToken(req.getParameter("accessToken"));
                }
                resp.setContentType("application/json;charset=utf-8");
                PrintWriter out = resp.getWriter();
                out.write(new ObjectMapper().writeValueAsString(RespBean.ok("注销成功!")));
                out.flush();
                out.close();
            }
    )
    .permitAll()
    .and()
    .csrf().disable().exceptionHandling()
}`}
            />
            <p>对于 Authing 而言，撤销 accessToken 意味着退出登录。</p>
            <div className="second-title">3. 注册</div>
            <p>管理员账号只能在 Authing 控制台手动添加。</p>
            <p>普通用户账号的注册放在「添加用户」功能模块说。</p>
          </DocBlock>
          <DocBlock title="资源管理+动态路由" keyId="m2e-5">
            <div className="descript">
              <div className="second-title">1. 菜单资源管理</div>
              <p>首先，介绍 Authing 定义的资源：</p>
              <p>
                Authing
                中的资源是你的业务系统中实际资源的标识符，一个资源可以是你的业务系统中的某一个实体，如
                Order，我们也可以对 order
                设定一个具体的操作，如：order:read；资源也可以是 UI
                界面上的某一个菜单，一个按钮。资源的具体定义可以参考文档，当你把所有业务资源都在
                Authing 中创建以后，就能控制对它们的访问、修改等权限。
              </p>
              <p>创建常规资源之前要先创建权限空间</p>
              <DocImg
                title="创建权限空间："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-03.png"
              />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2e-04.png" />
              <p>创建常规资源：</p>
              <DocImg
                title="需要选中权限空间"
                src="//files.authing.co/authing-website/doc-img/playground-b2e-05.png"
              />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2e-06.png" />
              <p>
                其中资源 code 和资源路径都是唯一标识，可以添加不同的资源操作。
              </p>
              <p>授权资源：</p>
              <p>此步骤 API 目前暂未开放，所以在控制台进行</p>
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2e-07.png" />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2e-08.png" />
              <p>说明一下：</p>
              <div className="descript-list">1. 项目中授权都是针对角色。</div>
              <div className="descript-list">
                2. 此处的资源标识符即表示用户可以访问的 menuId 号，Authing
                提供获取这些 menuId 的 API，系统调用 API
                获取之后进行逻辑判断；menuId
                对应的菜单数据需保存在项目的数据库中。
              </div>
              <div className="descript-list">
                3. 授权规则中的资源标识符若要输入多个，建议采用下划线分割。
              </div>
              <div className="descript-list">
                4.
                等数据资源权限完全开放可以在数据资源中构建，有特定菜单资源和树形结构选项，完善
                API 路径的填写，项目数据库可以不保存菜单数据。
              </div>

              <div className="second-title">2. 动态路由</div>
              <p>构造菜单数据：</p>
              <p>
                前端实现动态路由需要后端返回的是一个固定格式的
                json，此处仅说明相比原项目有变更之处。
              </p>
              <DocCode
                title="在 MenuService 中："
                code={`@Cacheable
public List<Menu> getMenusByAccessToken(String accessToken) {
    UserInfo userInfo = authenticationClient.getUserInfoByAccessToken(accessToken);
    String authingUserId = userInfo.getSub();
    // 从 Authing 获取被授权的资源列表
    List<String> menuIds = getAuthingUserResources(authingUserId);
    List<Menu> menuList = new ArrayList<>();
    menuIds.forEach((menuId) -> {
        Menu menu = menuMapper.getMenuById(menuId);
        menuList.add(menu);
    });
    return mergeChildren(menuList);
}

// 把父级相同的子菜单合并到一个父级下
public List<Menu> mergeChildren(List<Menu> menuList){
    List<Menu> res = new ArrayList<>();
    Map<Integer,Menu> menuMap = new HashMap<>();
    menuList.forEach(menu -> {
        if(menuMap.containsKey(menu.getId())){
            List<Menu> childrenList = menuMap.get(menu.getId()).getChildren();
            for(Menu childrenMenu : menu.getChildren()){
                childrenList.add(childrenMenu);
            }
            menuMap.get(menu.getId()).setChildren(childrenList);
        }else{
            menuMap.put(menu.getId(),menu);
        }
    });
    for(Map.Entry<Integer,Menu> entry : menuMap.entrySet()){
        res.add(entry.getValue());
    }
    return res;
}

// 获取 authing 用户的授权资源列表
public List<String> getAuthingUserResources(String authingUserId){
    GetUserRolesDto getUserRolesDto = new GetUserRolesDto();
    getUserRolesDto.setNamespace(namespace);
    getUserRolesDto.setUserId(authingUserId);
    // 获取用户角色
    RolePaginatedRespDto userRoles = managementClient.getUserRoles(getUserRolesDto);
    List<RoleDto> roles = userRoles.getData().getList();
    // 用户允许访问的全部 menuId
    List<String> resources = new ArrayList<>();
    roles.forEach((role) -> {
        GetRoleAuthorizedResourcesDto resourcesDto = new GetRoleAuthorizedResourcesDto();
        resourcesDto.setNamespace(namespace);
        resourcesDto.setCode(role.getCode());
        resourcesDto.setResourceType(ResourceItemDto.ResourceType.API.getValue());
        // 获取角色资源
        RoleAuthorizedResourcePaginatedRespDto roleAuthorizedResources = managementClient.getRoleAuthorizedResources(resourcesDto);
        List<RoleAuthorizedResourcesRespDto> list = roleAuthorizedResources.getData().getList();
        List<String> resource = new ArrayList<>();
        list.stream().forEach(item -> {
            // 分割字符获取全部 id
            String[] ids = item.getResourceCode().split(":")[1].split("_");
            resource.addAll(Arrays.asList(ids));
        });
        resources.addAll(resource);
    });
    return resources;
}`}
              />
              <p>权限拦截逻辑：</p>
              <DocCode
                title="原项目通过在实现 FilterInvocationSecurityMetadataSource 类的 CustomFilterInvocationSecurityMetadataSource 类中重写以下的 getAttributes() 方法实现。"
                code={`@Override
public Collection<ConfigAttribute> getAttributes(Object object) throws IllegalArgumentException {
    // 获取请求 url
    String requestUrl = ((FilterInvocation) object).getRequestUrl();
    List<Menu> menus = menuService.getMenus();
    Integer targetMenuId = 0;
    // 看与哪个 menu 匹配
    for (Menu menu : menus) {
        if (antPathMatcher.match(menu.getUrl(), requestUrl)) {
            targetMenuId = menu.getId();
        }
    }
    // 通过 Authing 获取该 menu 被授予了哪些角色
    List<String> authorizedRoles = menuService.selectAuthorizedRoles(targetMenuId);
    if(authorizedRoles.size() != 0) {
        return SecurityConfig.createList(authorizedRoles.toArray(new String[authorizedRoles.size()]));
    }
    // 数据库中不存在的角色，用于表示不匹配上面逻辑的路径需要登录后访问
    return SecurityConfig.createList("ROLE_LOGIN");
}`}
              />
              <DocCode
                title="MenuService 中 selectAuthorizedRoles() 、getAuthingRoleResources() 方法"
                code={`public List<String> selectAuthorizedRoles(Integer menuId){
    List<String> authorizedRoles = new ArrayList<>();
    // 获取全部角色
    ListRolesDto listRolesDto = new ListRolesDto();
    listRolesDto.setNamespace(namespace);
    List<RoleDto> roleDtoList = managementClient.listRoles(listRolesDto).getData().getList();
    roleDtoList.forEach(roleDto -> {
        List<Integer> resources = getAuthingRoleResources(roleDto.getCode());
        if(resources.contains(menuId)){
            authorizedRoles.add(roleDto.getCode());
        }
    });
    return authorizedRoles;
}

// 通过角色名获取拥有的资源
public List<Integer> getAuthingRoleResources(String roleName){
    GetRoleAuthorizedResourcesDto resourcesDto = new GetRoleAuthorizedResourcesDto();
    resourcesDto.setNamespace(namespace);
    resourcesDto.setCode(roleName);
    resourcesDto.setResourceType(ResourceItemDto.ResourceType.API.getValue());
    // 获取角色资源
    RoleAuthorizedResourcePaginatedRespDto roleAuthorizedResources = managementClient.getRoleAuthorizedResources(resourcesDto);
    List<RoleAuthorizedResourcesRespDto> list = roleAuthorizedResources.getData().getList();
    List<String> resource = new ArrayList<>();
    list.stream().forEach(item -> {
        // 分割字符获取全部 id
        String[] ids = item.getResourceCode().split(":")[1].split("_");
        resource.addAll(Arrays.asList(ids));
    });
    List<Integer> res = new ArrayList<>();
    resource.forEach(item -> {
        res.add(Integer.valueOf(item));
    });
    return res;
}`}
              />
              <p>
                这样就实现了根据登录用户的不同角色，配合 Authing
                控制台的授权规则，能访问不同的菜单资源。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="用户管理" keyId="m2e-6">
            <div className="descript">
              <div className="descript-list">
                前文已经提到，此处详细说明。原系统用户分为普通员工和管理员两种类型，只有管理员可以登录，管理员有不同的种类比如招聘主管、培训主管等
              </div>
              <div className="descript-list">
                普通用户实体类仅表示含义，而能登录的管理员用户实体类需要实现
                UserDetails 接口接入 SpringSecurity
              </div>
              <div className="descript-list">
                而接入 Authing 后，二者都属于 Authing
                用户一种类型（用户池相同），区别在于普通员工没有角色
              </div>
              <div className="descript-list">
                4. 接入 Authing后，二者实体类都需要添加一些额外的属性，比如
                ownerId 来保存对应的 Authing userId
              </div>
              <div className="second-title">1. 员工管理</div>
              <p>Authing 用户和项目 Employee 实体类的相互转换功能</p>

              <DocCode
                title="写一个转换工具类 AuthingUserEmployeeConverter 如下："
                code={`@Component
                public class AuthingUserEmployeeConverter {
                    @Autowired
                    EmployeeService employeeService;
                    @Autowired
                    ManagementClient managementClient;
                    @Autowired
                    NationService nationService;
                    @Autowired
                    PoliticsstatusService politicsstatusService;
                    @Autowired
                    JobLevelService jobLevelService;
                    @Autowired
                    PositionService positionService;
                    @Autowired
                    DepartmentService departmentService;
                    @Autowired
                    SalaryService salaryService;
                
                    // authing 用户转换成 employee
                    public Employee AuthToEmp(UserDto userDto){
                        Employee employee = new Employee();
                        employee.setOwnerId(userDto.getUserId());
                        if(StrUtil.isNotBlank(userDto.getExternalId())) {
                            employee.setId(Integer.valueOf(userDto.getExternalId()));
                        }
                        String username = userDto.getUsername();
                        // 如果是从数据库中迁移，含有 externalId，则从拼接字符串中拆分出原来的 name
                        if(StrUtil.isNotBlank(userDto.getExternalId())
                                && StrUtil.contains(userDto.getUsername(),userDto.getExternalId())){
                            StrUtil.removeSuffix(userDto.getUsername(), userDto.getExternalId());
                        }
                        employee.setName(username);
                
                        if(StrUtil.equals(userDto.getGender().getValue(),"M")){
                            employee.setGender("男");
                        } else if (StrUtil.equals(userDto.getGender().getValue(),"F")) {
                            employee.setGender("女");
                        }
                
                        employee.setBirthday(DateUtil.parseDate(userDto.getBirthdate()));
                
                        LinkedHashMap<String,Object> customData = (LinkedHashMap) userDto.getCustomData();
                        if(customData.containsKey("idCard")) {
                            employee.setIdCard((String) customData.get("idCard"));
                        }
                        if(customData.containsKey("wedlock")) {
                            employee.setWedlock((String) customData.get("wedlock"));
                        }
                        if(customData.containsKey("nationId")) {
                            employee.setNationId((Integer) customData.get("nationId"));
                            employee.setNation(nationService.getNationById((Integer) customData.get("nationId")));
                        }
                        if(customData.containsKey("nativePlace")) {
                            employee.setNativePlace((String) customData.get("nativePlace"));
                        }
                        if(customData.containsKey("politicId")) {
                            employee.setPoliticId((Integer) customData.get("politicId"));
                            employee.setPoliticsstatus(politicsstatusService.getPoliticsstatusById((Integer) customData.get("politicId")));
                        }
                
                        employee.setAddress(userDto.getAddress());
                
                        // 获取用户部门
                        Department department = departmentService.getAuthingDepByUser(userDto.getUserId());
                        employee.setAuthingDepartmentId(department.getAuthingDepartmentId());
                        employee.setDepartment(department);
                
                        if(customData.containsKey("jobLevelId")) {
                            employee.setJobLevelId((Integer) customData.get("jobLevelId"));
                            employee.setJobLevel(jobLevelService.getJobLevelById((Integer) customData.get("jobLevelId")));
                        }
                        if(customData.containsKey("posId")) {
                            employee.setPosId((Integer) customData.get("posId"));
                            employee.setPosition(positionService.getPositionById((Integer) customData.get("posId")));
                        }
                        if(customData.containsKey("engageForm")) {
                            employee.setEngageForm((String) customData.get("engageForm"));
                        }
                        if(customData.containsKey("tiptopDegree")) {
                            employee.setTiptopDegree((String) customData.get("tiptopDegree"));
                        }
                        if(customData.containsKey("specialty")) {
                            employee.setSpecialty((String) customData.get("specialty"));
                        }
                        if(customData.containsKey("school")) {
                            employee.setSchool((String) customData.get("school"));
                        }
                        if(customData.containsKey("beginDate")) {
                            employee.setBeginDate(DateUtil.parseDate((String) customData.get("beginDate")));
                        }
                        if(customData.containsKey("workState")) {
                            employee.setWorkState((String) customData.get("workState"));
                        }
                        if(customData.containsKey("workID")) {
                            employee.setWorkID((String) customData.get("workID"));
                        }
                        if(customData.containsKey("contractTerm")) {
                            employee.setContractTerm(Double.valueOf(((String) customData.get("contractTerm"))));
                        }
                        if(customData.containsKey("conversionTime")) {
                            employee.setConversionTime(DateUtil.parseDate((String) customData.get("conversionTime")));
                        }
                        if(customData.containsKey("notWorkDate")) {
                            employee.setNotWorkDate(DateUtil.parseDate((String) customData.get("notWorkDate")));
                        }
                        if(customData.containsKey("beginContract")) {
                            employee.setBeginContract(DateUtil.parseDate((String) customData.get("beginContract")));
                        }
                        if(customData.containsKey("endContract")) {
                            employee.setEndContract(DateUtil.parseDate((String) customData.get("endContract")));
                        }
                        if(customData.containsKey("workAge")) {
                            employee.setWorkAge((Integer) customData.get("workAge"));
                        }
                
                        if(customData.containsKey("salaryId")){
                            employee.setSalaryId((Integer) customData.get("salaryId"));
                            employee.setSalary(salaryService.getSalaryById((Integer) customData.get("salaryId")));
                        }
                
                        return employee;
                    }
                
                    // employee 转换成 authing 用户
                    public CreateUserInfoDto EmpToAuth(Employee employee){
                        CreateUserInfoDto createUserInfoDto = new CreateUserInfoDto();
                        if(employee.getId() != null) {
                            createUserInfoDto.setExternalId(Integer.toString(employee.getId()));
                        }
                        // 由于原本数据库中很多重复的重名数据，而 username 将作为 authing 的唯一标识，此处拼接 username 为 username + id
                        String[] arr = new String[2];
                        arr[0] = employee.getName();
                        arr[1] = "";
                        if(employee.getId() != null && !StrUtil.contains(employee.getName(),Integer.toString(employee.getId()))) {
                            arr[1] = Integer.toString(employee.getId());
                        }
                        createUserInfoDto.setUsername(StrUtil.concat(true,arr));
                
                        if(StrUtil.equals(employee.getGender(),"男")) {
                            createUserInfoDto.setGender(CreateUserInfoDto.Gender.M);
                        }else if(StrUtil.equals(employee.getGender(),"女")){
                            createUserInfoDto.setGender(CreateUserInfoDto.Gender.F);
                        }else{
                            createUserInfoDto.setGender(CreateUserInfoDto.Gender.U);
                        }
                        createUserInfoDto.setBirthdate(DateUtil.formatDate(employee.getBirthday()));
                        // customData 存放 authing 不默认提供但是 employee 中包含的数据
                        CustomData customData = new CustomData();
                        customData.setIdCard(employee.getIdCard());
                        customData.setWedlock(employee.getWedlock());
                        customData.setNationId(employee.getNationId());
                        customData.setNativePlace(employee.getNativePlace());
                        customData.setPoliticId(employee.getPoliticId());
                
                //        createUserInfoDto.setEmail(employee.getEmail());
                //        createUserInfoDto.setPhone(employee.getPhone());
                
                        createUserInfoDto.setAddress(employee.getAddress());
                
                        List<String> departmentIds = new ArrayList<>();
                        if(StrUtil.isNotBlank(employee.getAuthingDepartmentId())) {
                            departmentIds.add(employee.getAuthingDepartmentId());
                        }
                        createUserInfoDto.setDepartmentIds(departmentIds);
                
                        customData.setJobLevelId(employee.getJobLevelId());
                        customData.setPosId(employee.getPosId());
                        customData.setEngageForm(employee.getEngageForm());
                        customData.setTiptopDegree(employee.getTiptopDegree());
                        customData.setSpecialty(employee.getSpecialty());
                        customData.setSchool(employee.getSchool());
                        customData.setBeginDate(employee.getBeginDate());
                        customData.setWorkState(employee.getWorkState());
                        customData.setWorkID(employee.getWorkID());
                        // 类型转换
                        customData.setContractTerm(Double.toString(employee.getContractTerm()));
                        customData.setConversionTime(employee.getConversionTime());
                        customData.setNotWorkDate(employee.getNotWorkDate());
                        customData.setBeginContract(employee.getBeginContract());
                        customData.setEndContract(employee.getEndContract());
                        customData.setWorkAge(employee.getWorkAge());
                        customData.setSalaryId(employee.getSalaryId());
                        createUserInfoDto.setCustomData(customData);
                        return createUserInfoDto;
                    }
                    
                    // 把原本数据库中的 employee 全部转换成 authing 用户,需手动调用
                    public void batchCreateAuthingUser(){
                        List<Employee> list = employeeService.getAllEmployee();
                        List<CreateUserInfoDto> authingUserList = new ArrayList<>();
                        // 批量创建一次最多 50 个
                        for(int i = 1;i <= list.size();i++){
                            authingUserList.add(this.EmpToAuth(list.get(i-1)));
                            if(i % 50 == 0){
                                CreateUserBatchReqDto reqDto = new CreateUserBatchReqDto();
                                reqDto.setList(authingUserList);
                                UserListRespDto respDto = managementClient.createUsersBatch(reqDto);
                                if(respDto.getStatusCode() != null){
                                    authingUserList.clear();
                                }
                            }
                        }
                    }
                }`}
              />

              <p>说明：</p>
              <div className="descript-list">
                1. 由于原系统中包含很多普通员工，此处提供调用 Authing SDK
                批量创建的方法示例，实际使用中，初始化项目时调用一次该方法即可。
              </div>
              <div className="descript-list">
                2. 原系统中很多普通员工以 id 为唯一标识，有很多同名的数据，而
                Authing 用户池中 username
                也是唯一标识（本示例中用作登录账号），所以在转换中以 原 name
                拼接 id 的形式构造了新的 Authing username。
              </div>
              <div className="descript-list">
                3. 可以注意一下用户自定义字段 customData 的 构造/获取 方式。
              </div>
              <p>列表+搜索功能</p>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-09.png"
              />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-b2e-10.png" />
              <DocCode
                title="后端逻辑：
EmployeeService 中 getAuthingEmployeeByPage() 方法，可以根据关键词搜索、根据用户信息高级搜索并分页展示："
                code={`// 从 authing 搜索普通用户并转换类型
                public RespPageBean getAuthingEmployeeByPage(Integer page, Integer limit, Employee employee, Date[] beginDateScope){
                    ListUsersRequestDto reqDto = new ListUsersRequestDto();
                    if(StrUtil.isNotBlank(employee.getName())) {
                        reqDto.setKeywords(employee.getName());
                    }
                    ListUsersOptionsDto optionsDto = new ListUsersOptionsDto();
                    List<String> searchList = new ArrayList<>();
                    // 设置模糊搜索的字段
                    searchList.add("username");
                    optionsDto.setFuzzySearchOn(searchList);
                    // 获取用户自定义字段
                    optionsDto.setWithCustomData(true);
                    // 设置排序方式
                    List<SortingDto> sortingDtoList = new ArrayList<>();
                    SortingDto sortingDto = new SortingDto();
                    sortingDto.setField(SortingDto.Field.USERNAME);
                    sortingDto.setOrder(SortingDto.Order.ASC);
                    // 设置分页
                    PaginationDto paginationDto = new PaginationDto();
                    paginationDto.setPage(page);
                        // authing 分页每页最多 50 条数据
                    if(limit > 50){
                        return new RespPageBean();
                    }
                    paginationDto.setLimit(limit);
                    optionsDto.setPagination(paginationDto);
                    reqDto.setOptions(optionsDto);
            
                    // 只选出普通用户（externalId 不为空）
                    List<ListUsersAdvancedFilterItemDto> advancedFilterList = new ArrayList<>();
                    ListUsersAdvancedFilterItemDto itemDto = new ListUsersAdvancedFilterItemDto();
                    itemDto.setField("externalId");
                    itemDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.NOT_NULL);
                    advancedFilterList.add(itemDto);
            
                    // 根据其他条件高级搜索
                    if(employee.getPoliticId() != null){
                        ListUsersAdvancedFilterItemDto politicIdDto = new ListUsersAdvancedFilterItemDto();
                        politicIdDto.setField("politicId");
                        politicIdDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.EQUAL);
                        politicIdDto.setValue(employee.getPoliticId());
                        advancedFilterList.add(politicIdDto);
                    }
                    if(employee.getNationId() != null){
                        ListUsersAdvancedFilterItemDto nationIdDto = new ListUsersAdvancedFilterItemDto();
                        nationIdDto.setField("nationId");
                        nationIdDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.EQUAL);
                        nationIdDto.setValue(employee.getNationId());
                        advancedFilterList.add(nationIdDto);
                    }
                    if(employee.getJobLevelId() != null){
                        ListUsersAdvancedFilterItemDto jobLevelIdDto = new ListUsersAdvancedFilterItemDto();
                        jobLevelIdDto.setField("jobLevelId");
                        jobLevelIdDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.EQUAL);
                        jobLevelIdDto.setValue(employee.getJobLevelId());
                        advancedFilterList.add(jobLevelIdDto);
                    }
                    if(employee.getPosId() != null){
                        ListUsersAdvancedFilterItemDto posIdDto = new ListUsersAdvancedFilterItemDto();
                        posIdDto.setField("posId");
                        posIdDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.EQUAL);
                        posIdDto.setValue(employee.getPosId());
                        advancedFilterList.add(posIdDto);
                    }
                    if(StrUtil.isNotBlank(employee.getEngageForm())){
                        ListUsersAdvancedFilterItemDto engageFormDto = new ListUsersAdvancedFilterItemDto();
                        engageFormDto.setField("engageForm");
                        engageFormDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.EQUAL);
                        engageFormDto.setValue(employee.getEngageForm());
                        advancedFilterList.add(engageFormDto);
                    }
                    if(beginDateScope != null){
                        ListUsersAdvancedFilterItemDto beginDateDto = new ListUsersAdvancedFilterItemDto();
                        beginDateDto.setField("beginDate");
                        beginDateDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.BETWEEN);
                        beginDateDto.setValue(beginDateScope);
                        advancedFilterList.add(beginDateDto);
                    }
            
                    reqDto.setAdvancedFilter(advancedFilterList);
                    UserPaginatedRespDto respDto = managementClient.listUsers(reqDto);
            
                    List<UserDto> userDtoList = respDto.getData().getList();
                    List<Employee> employeeList = new ArrayList<>();
            
                    if(userDtoList.size() != 0){
                        userDtoList.forEach(userDto -> {
                            Employee emp = authingUserEmployeeConverter.AuthToEmp(userDto);
                            employeeList.add(emp);
                        });
                    }
            
                    RespPageBean bean = new RespPageBean();
                    bean.setData(employeeList);
                    bean.setTotal(new Long(respDto.getData().getTotalCount()));
                    return bean;
                }`}
              />
              <p className="third-title">添加功能：</p>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-11.png"
              />
              <DocCode
                title="后端逻辑：EmployeeService 中的 addAuthEmp() 方法："
                code={`public RespBean addAuthEmp(Employee employee) {
                CreateUserInfoDto createUserInfoDto = authingUserEmployeeConverter.EmpToAuth(employee);
                CreateUserReqDto reqDto = new CreateUserReqDto();
                BeanUtils.copyProperties(createUserInfoDto,reqDto);
                if(StrUtil.equals(createUserInfoDto.getGender().getValue(),"M")){
                    reqDto.setGender(CreateUserReqDto.Gender.M);
                } else if (StrUtil.equals(createUserInfoDto.getGender().getValue(),"F")) {
                    reqDto.setGender(CreateUserReqDto.Gender.F);
                }else{
                    reqDto.setGender(CreateUserReqDto.Gender.U);
                }
                UserSingleRespDto respDto = managementClient.createUser(reqDto);
                return respDto.getStatusCode() == 200 ? RespBean.ok("添加成功") : RespBean.error(respDto.getMessage());
            }`}
              />
              <p>
                说明：
                此处添加用户的同时必须设置用户部门，而设置用户部门后，对于
                Authing 而言就相当于用户入职。
              </p>
              <p className="third-title">编辑功能：</p>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-12.png"
              />
              <p>后端逻辑：</p>
              <DocCode
                title="修改：EmployeeService 中："
                code={`public RespBean updateAuthEmp(Employee employee) {
    CreateUserInfoDto createUserInfoDto = authingUserEmployeeConverter.EmpToAuth(employee);
    UpdateUserReqDto reqDto = new UpdateUserReqDto();
    BeanUtils.copyProperties(createUserInfoDto,reqDto);

    reqDto.setUserId(employee.getOwnerId());

    if(StrUtil.equals(createUserInfoDto.getGender().getValue(),"M")){
        reqDto.setGender(UpdateUserReqDto.Gender.M);
    } else if (StrUtil.equals(createUserInfoDto.getGender().getValue(),"F")) {
        reqDto.setGender(UpdateUserReqDto.Gender.F);
    }else{
        reqDto.setGender(UpdateUserReqDto.Gender.U);
    }

    // 改变用户部门
    SetUserDepartmentsDto setUserDepartmentsDto = new SetUserDepartmentsDto();
    setUserDepartmentsDto.setUserId(employee.getOwnerId());
    List<SetUserDepartmentDto> list = new ArrayList<>();
    SetUserDepartmentDto setUserDepartmentDto = new SetUserDepartmentDto();
    setUserDepartmentDto.setDepartmentId(employee.getAuthingDepartmentId());
    list.add(setUserDepartmentDto);
    setUserDepartmentsDto.setDepartments(list);
    managementClient.setUserDepartments(setUserDepartmentsDto);

    UserSingleRespDto respDto = managementClient.updateUser(reqDto);
    return respDto.getStatusCode() == 200 ? RespBean.ok("修改成功") : RespBean.error(respDto.getMessage());
}`}
              />

              <p>获取用户部门</p>
              <DocCode
                title="DepartmentService 中 getAuthingDepByUser() 方法："
                code={`public Department getAuthingDepByUser(String authingUserId){
    GetUserDepartmentsDto reqDto = new GetUserDepartmentsDto();
    reqDto.setUserId(authingUserId);
    UserDepartmentPaginatedRespDto respDto = managementClient.getUserDepartments(reqDto);
    List<UserDepartmentRespDto> departments = respDto.getData().getList();
    Department department = new Department();
    if(departments.size() != 0){
        // vhr 职工只属于一个部门
        UserDepartmentRespDto departmentDto = departments.get(0);
        String departmentId = departmentDto.getDepartmentId();
        String departmentName = departmentDto.getName();
        department.setAuthingDepartmentId(departmentId);
        department.setName(departmentName);
    }
    return department;
}`}
              />
              <p>删除功能：</p>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-13.png"
              />
              <DocCode
                title="后端逻辑："
                code={`public RespBean deleteAuthEmpByEid(String id) {
    DeleteUsersBatchDto reqDto = new DeleteUsersBatchDto();
    List<String> authingUserIdList = new ArrayList<>();
    authingUserIdList.add(id);
    reqDto.setUserIds(authingUserIdList);
    IsSuccessRespDto respDto = managementClient.deleteUsersBatch(reqDto);
    return respDto.getStatusCode() == 200 ? RespBean.ok("删除成功") : RespBean.error(respDto.getMessage());
}`}
              />
              <p>
                Authing 提供批量删除功能，只删除一个就传只有一个元素的 List。
              </p>
              <div className="second-title">
                2. 管理员管理
                <div className="second-title-description">
                  为了接入 SpringSecurity，需要了解实现 UserDetails 类的 Hr
                  类以及实现 UserDetailsService 接口的 HrService 类，尤其是 Hr
                  类的 getAuthorities() 方法以及 HrService 类的
                  loadUserByUsername() 方法。
                </div>
              </div>
              <p>Authing 用户和项目 Hr 实体类的相互转换功能</p>

              <DocCode
                title="写一个转换工具类 AuthingUserToHrConverter 如下："
                code={`@Component
                public class AuthingUserToHrConverter {
                    @Autowired
                    ManagementClient managementClient;
                    @Value("\${authing.config.appId}")
                    String namespace;
                
                    // authing 用户转换成 hr 实体类
                    public Hr convertAuthingUserToHr(UserDto authingUser){
                        Hr hr = new Hr();
                        hr.setName(authingUser.getName());
                        hr.setPhone(authingUser.getPhone());
                        hr.setAddress(authingUser.getAddress());
                        if(authingUser.getStatus().getValue()=="Activated") {
                            hr.setEnabled(true);
                        }else{
                            hr.setEnabled(false);
                        }
                        hr.setUsername(authingUser.getUsername());
                        hr.setUserface(authingUser.getPhoto());
                        // authing 用户不自带 remark 属性，需要自定义用户字段
                        if(authingUser.getCustomData() != null){
                            LinkedHashMap<String,String> map = (LinkedHashMap) authingUser.getCustomData();
                            hr.setRemark(map.get("remark"));
                        }
                
                        // authing 用户的 password 属性无法获取（解密）
                
                        // 获取用户角色
                        List<Role> roleList = new ArrayList<>();
                        GetUserRolesDto getUserRolesDto = new GetUserRolesDto();
                        getUserRolesDto.setUserIdType("username");
                        getUserRolesDto.setUserId(authingUser.getUsername());
                        getUserRolesDto.setNamespace(namespace);
                        RolePaginatedRespDto respDto = managementClient.getUserRoles(getUserRolesDto);
                        List<RoleDto> authingRoleList = respDto.getData().getList();
                        for (RoleDto authingRole:authingRoleList){
                            roleList.add(convertAuthingRoleToRole(authingRole));
                        }
                        hr.setRoles(roleList);
                
                        hr.setOwnerId(authingUser.getUserId());
                        return hr;
                    }
                
                    // authing 用户角色和 Role 实体类的对应
                    public Role convertAuthingRoleToRole(RoleDto authingRole){
                        Role role = new Role();
                        role.setName(authingRole.getCode());
                        role.setNameZh(authingRole.getDescription());
                        return role;
                    }
                }`}
              />
              <p>列表+搜索功能</p>
              <p>仅支持根据用户名模糊搜索</p>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-14.png"
              />
              <p>后端逻辑：</p>
              <DocCode
                title="HrService 中 getAllHrs() 方法："
                code={`public List<Hr> getAllHrs(String keywords){
    List<UserDto> userList = new ArrayList<>();
    ListUsersRequestDto reqDto = new ListUsersRequestDto();
    if(StrUtil.isNotBlank(keywords)) {
        reqDto.setKeywords(keywords);
    }
    ListUsersOptionsDto optionsDto = new ListUsersOptionsDto();
    List<String> searchList = new ArrayList<>();
    // 设置模糊搜索的字段
    searchList.add("username");
    optionsDto.setFuzzySearchOn(searchList);
    // 获取用户自定义字段 remark
    optionsDto.setWithCustomData(true);
    reqDto.setOptions(optionsDto);

    // 只选出管理员用户（externalId 为空）
    List<ListUsersAdvancedFilterItemDto> advancedFilterList = new ArrayList<>();
    ListUsersAdvancedFilterItemDto itemDto = new ListUsersAdvancedFilterItemDto();
    itemDto.setField("externalId");
    itemDto.setOperator(ListUsersAdvancedFilterItemDto.Operator.IS_NULL);
    advancedFilterList.add(itemDto);
    reqDto.setAdvancedFilter(advancedFilterList);

    UserPaginatedRespDto respDto = managementClient.listUsers(reqDto);
    userList.addAll(respDto.getData().getList());
    List<Hr> hrList = new ArrayList<>();
    userList.forEach(userDto -> {
        Hr hr = authingUserToHrConverter.convertAuthingUserToHr(userDto);
        hrList.add(hr);
    });
    return hrList;
}`}
              />
              <p>修改角色功能：</p>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-15.png"
              />
              <p>后端逻辑：</p>
              <DocCode
                title="获取全部角色 RoleService 中 getAllRoles() 方法："
                code={`public List<Role> getAllRoles() {
                  ListRolesDto reqDto = new ListRolesDto();
                  reqDto.setNamespace(namespace);
                  RolePaginatedRespDto respDto = managementClient.listRoles(reqDto);
                  List<RoleDto> authingRoleList = respDto.getData().getList();
                  List<Role> roleList = new ArrayList<>();
                  authingRoleList.forEach(authingRole -> {
                      Role role = authingUserToHrConverter.convertAuthingRoleToRole(authingRole);
                      roleList.add(role);
                  });
                  return roleList;
              }`}
              />
              <DocCode
                title="修改角色 HrService 中 updateHrRole() 方法："
                code={`@Transactional
                public RespBean updateHrRole(String authingUserId, String[] roleCodes) {
                    ListRolesDto listRolesDto = new ListRolesDto();
                    listRolesDto.setNamespace(namespace);
                    // 获取全部用户角色
                    RolePaginatedRespDto rolePaginatedRespDto = managementClient.listRoles(listRolesDto);
                    List<RoleDto> roleDtoList = rolePaginatedRespDto.getData().getList();
                    List<TargetDto> target = new ArrayList<>();
                    TargetDto targetDto = new TargetDto();
                    targetDto.setTargetType(TargetDto.TargetType.USER);
                    targetDto.setTargetIdentifier(authingUserId);
                    target.add(targetDto);
                    // 清空该用户角色
                    for(RoleDto roleDto:roleDtoList){
                        RevokeRoleDto revokeRoleDto = new RevokeRoleDto();
                        revokeRoleDto.setTargets(target);
                        revokeRoleDto.setNamespace(namespace);
                        // code 不同
                        revokeRoleDto.setCode(roleDto.getCode());
                        IsSuccessRespDto isSuccessRespDto = managementClient.revokeRole(revokeRoleDto);
                        if(isSuccessRespDto.getStatusCode() != 200){
                            return RespBean.error(isSuccessRespDto.getMessage());
                        }
                    }
                    // 添加角色
                    for(String code:roleCodes){
                        AssignRoleDto assignRoleDto = new AssignRoleDto();
                        assignRoleDto.setTargets(target);
                        assignRoleDto.setNamespace(namespace);
                        assignRoleDto.setCode(code);
                        IsSuccessRespDto isSuccessRespDto = managementClient.assignRole(assignRoleDto);
                        if(isSuccessRespDto.getStatusCode() != 200){
                            return RespBean.error(isSuccessRespDto.getMessage());
                        }
                    }
                    return RespBean.ok("修改成功！");
                }`}
              />
              <p>需要先清空角色再添加</p>
              <p>修改用户状态：</p>
              <p>HrService 中 updateHrStatus() 方法：</p>
              <DocCode
                title="后端逻辑："
                code={`public RespBean updateHrStatus(Hr hr){
    UpdateUserReqDto reqDto = new UpdateUserReqDto();
    reqDto.setUserId(hr.getOwnerId());
    if(hr.isEnabled()){
        reqDto.setStatus(UpdateUserReqDto.Status.ACTIVATED);
    }else{
        reqDto.setStatus(UpdateUserReqDto.Status.DEACTIVATED);
    }
    UserSingleRespDto respDto = managementClient.updateUser(reqDto);
    return respDto.getStatusCode() == 200 ?
            RespBean.ok("修改成功！") : RespBean.error(respDto.getMessage());
}`}
              />
            </div>
          </DocBlock>
          <DocBlock title="角色管理+授权管理" keyId="m2e-7">
            <div className="descript">
              <p>示例系统中角色和授权耦合度很高，所以放在一起说明</p>
              <DocImg
                title=""
                src="//files.authing.co/authing-website/doc-img/playground-b2e-16.png"
              />
              <p>角色管理后端逻辑：</p>
              <p>列表展示：</p>
              <DocCode
                title="RoleService 中:"
                code={`public List<Role> getAllRoles() {
    ListRolesDto reqDto = new ListRolesDto();
    reqDto.setNamespace(namespace);
    RolePaginatedRespDto respDto = managementClient.listRoles(reqDto);
    List<RoleDto> authingRoleList = respDto.getData().getList();
    List<Role> roleList = new ArrayList<>();
    authingRoleList.forEach(authingRole -> {
        Role role = authingUserToHrConverter.convertAuthingRoleToRole(authingRole);
        roleList.add(role);
    });
    return roleList;
}`}
              />
              <p>添加角色：</p>
              <DocCode
                title="RoleService 中 :"
                code={`public RespBean addAuthingRole(Role role) {
                  CreateRoleDto createRoleDto = new CreateRoleDto();
                  if (!role.getName().startsWith("ROLE_")) {
                      createRoleDto.setCode("ROLE_" + role.getName());
                  }else {
                      createRoleDto.setCode(role.getName());
                  }
                  createRoleDto.setDescription(role.getNameZh());
                  createRoleDto.setNamespace(namespace);
                  RoleSingleRespDto respDto = managementClient.createRole(createRoleDto);
                  return respDto.getStatusCode() == 200 ?
                          RespBean.ok("添加成功！") : RespBean.error(respDto.getMessage());
              }`}
              />
              <p>删除角色：</p>
              <DocCode
                title="RoleService 中 :"
                code={`public RespBean deleteRoleByName(String roleName) {
                  DeleteRoleDto reqDto = new DeleteRoleDto();
                  reqDto.setNamespace(namespace);
                  List<String> codeList = new ArrayList<>();
                  codeList.add(roleName);
                  reqDto.setCodeList(codeList);
                  IsSuccessRespDto respDto = managementClient.deleteRolesBatch(reqDto);
                  return respDto.getStatusCode() == 200 ?
                          RespBean.ok("删除成功！") : RespBean.error(respDto.getMessage());
              }`}
              />
              <div className="second-title">授权管理后端逻辑：</div>
              <p>列表展示：</p>
              <p>MenuService 中 getAuthingRoleResources()，之前展示过</p>
              <p>修改/删除授权：</p>
              <p>
                thing 暂未开放相关 API，目前可移步 Authing
                控制台手动修改，敬请期待。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="组织机构管理" keyId="m2e-8">
            <div className="descript">
              <p>说明:</p>
              <div className="descript-list">
                1. Authing
                中的组织机构管理，根结点为组织（可以有多个），其他子节点为部门，操作的
                API 不同
              </div>
              <div className="descript-list">
                2. 此处接入设置根结点组织为
                vhr，股东会为第一个子部门，其他完全相同，获取时只获取根节点的子部门
              </div>
              <div className="descript-list">
                3. 第一个部门的添加要在 Authing 控制台进行
              </div>
              <div className="descript-list">
                4. 示例系统和 Authing 控制台都不允许删除有子部门的部门
              </div>
              <DocImg
                title="前端界面："
                src="//files.authing.co/authing-website/doc-img/playground-b2e-17.png"
              />
              <div className="second-title">后端逻辑：</div>
              <p>列表功能：</p>
              <DocCode
                title="DepartmentService 中："
                code={`public List<Department> getAuthingDepartments(){
    // 获取根组织
    GetOrganizationDto getOrganizationDto = new GetOrganizationDto();
    getOrganizationDto.setOrganizationCode("vhr");
    OrganizationDto organizationDto = managementClient.getOrganization(getOrganizationDto).getData();
    DepartmentDto departmentDto = new DepartmentDto();

    BeanUtils.copyProperties(organizationDto,departmentDto);
    return listChildren(departmentDto);
}

// 获取子部门并作类型转换
public List<Department> listChildren(DepartmentDto departmentDto){
    if(!departmentDto.getHasChildren()){
        return null;
    }
    ListChildrenDepartmentsDto reqDto = new ListChildrenDepartmentsDto();
    reqDto.setDepartmentId(departmentDto.getDepartmentId());
    reqDto.setOrganizationCode(departmentDto.getOrganizationCode());
    DepartmentPaginatedRespDto respDto = managementClient.listChildrenDepartments(reqDto);
    List<DepartmentDto> list = respDto.getData().getList();
    List<Department> res = new ArrayList<>();
    list.forEach(child -> {
        Department department = authingDepToDepConverter.convert(child);
        // 手动设置父部门 id
        department.setParentAuthingId(departmentDto.getDepartmentId());
        if(child.getHasChildren()) {
            department.setChildren(listChildren(child));
        }
        res.add(department);
    });
    return res;
}`}
              />
              <p>添加部门：</p>
              <DocCode
                title="DepartmentService 中："
                code={`public RespBean addAuthingDep(Department dep){
    CreateDepartmentReqDto reqDto = new CreateDepartmentReqDto();
    reqDto.setOrganizationCode("vhr");
    reqDto.setName(dep.getName());
    reqDto.setParentDepartmentId(dep.getParentAuthingId());
    DepartmentSingleRespDto respDto = managementClient.createDepartment(reqDto);
    dep.setAuthingDepartmentId(respDto.getData().getDepartmentId());
    return respDto.getStatusCode() == 200 ?
            RespBean.ok("添加成功！",dep) : RespBean.error(respDto.getMessage());
}`}
              />
              <p>删除部门：</p>
              <DocCode
                title="DepartmentService 中："
                code={`public RespBean deleteDepByAuthingDepId(String authingDepId) {
                  DeleteDepartmentReqDto reqDto = new DeleteDepartmentReqDto();
                  reqDto.setOrganizationCode("vhr");
                  reqDto.setDepartmentId(authingDepId);
                  IsSuccessRespDto respDto = managementClient.deleteDepartment(reqDto);
                  return respDto.getStatusCode() == 200 ?
                          RespBean.ok("删除成功！") : RespBean.error(respDto.getMessage());
              }`}
              />
            </div>
          </DocBlock>
          <DocBlock title="员工套账管理" keyId="m2e-9">
            <p>
              此块特别之处在于属于系统业务逻辑，Employee 实体类中有 Salary
              属性标识工资套账，我们添加一个 SalaryId 属性用于标识，并且在
              Authing 用户类中作为扩展字段存储，即可实现功能。
            </p>
            <DocImg
              title="前端界面："
              src="//files.authing.co/authing-website/doc-img/playground-b2e-18.png"
            />
            <p>后端逻辑：</p>
            <DocCode
              title="EmployeeService 中 updateAuthEmpSalary() 方法："
              code={`public RespBean updateAuthEmpSalary(Employee employee) {
    CreateUserInfoDto createUserInfoDto = authingUserEmployeeConverter.EmpToAuth(employee);
    UpdateUserReqDto reqDto = new UpdateUserReqDto();
    BeanUtils.copyProperties(createUserInfoDto,reqDto);

    reqDto.setUserId(employee.getOwnerId());

    if(StrUtil.equals(createUserInfoDto.getGender().getValue(),"M")){
        reqDto.setGender(UpdateUserReqDto.Gender.M);
    } else if (StrUtil.equals(createUserInfoDto.getGender().getValue(),"F")) {
        reqDto.setGender(UpdateUserReqDto.Gender.F);
    }else{
        reqDto.setGender(UpdateUserReqDto.Gender.U);
    }

    UserSingleRespDto respDto = managementClient.updateUser(reqDto);
    return respDto.getStatusCode() == 200 ? RespBean.ok("修改成功") : RespBean.error(respDto.getMessage());
}`}
            />
            <p>
              实际上改变的值存储在 Employee 类的 SalaryId 属性，转换成
              AuthingUser 后存储在 CustomData 属性列中。
            </p>
          </DocBlock>
        </div>
        <div className="toc-rigth">
          <div className="m2e-toc"></div>
        </div>
      </div>
      <div style={{ clear: "both" }}></div>
    </div>
  );
};
